import { useEffect } from 'react';

import { Stage } from '@eventbrite/webapp-constants';

import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';

import { isEventEnded } from '../../utils/bodyUtils';
import { useTrackingBeacons } from '../useTrackingBeacons/';

import { pixelsTracking } from './pixelsTracking';

export const useTrackingPixels = ({ stage }: { stage: Stage }) => {
  const { id: eventId, organizationId, isProtected, status } = useBasicInfo();
  const [trackingBeacons] = useTrackingBeacons();

  useEffect(() => {
    if (isProtected || isEventEnded(status)) {
      return;
    }
    if (trackingBeacons) {
      let environment;
      if (stage === Stage.PROD) {
        environment = 'prod';
      } else if (stage === Stage.TEST) {
        environment = 'qa';
      } else {
        environment = 'dev';
      }
      const debugging = stage !== Stage.PROD && process.env.NEXT_PUBLIC_TRACKING_PIXEL_DEBUG === 'true';

      pixelsTracking({
        eventId,
        organizationId,
        environment,
        debugging,
        trackingBeacons,
      });
    }
    // only tracking beacons can change, so we can safely skip the dependencies
  }, [trackingBeacons]); // eslint-disable-line react-hooks/exhaustive-deps
};
